<template>
    <el-card>
        <el-row class="report__title">举报</el-row>
        <!-- 搜索 -->
        <el-row class="report__search">
            <div class="item">
                <el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" @change="handleDateChange">
                </el-date-picker>
            </div>
            <div class="item">
                <span>举报原因：</span>
                <el-select v-model="search.reportTypeId" placeholder="请选择举报原因" clearable>
                    <el-option v-for="item in reportTypeList" :key="item.id" :label="item.reportTypeContent"
                        :value="item.reportTypeId">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>举报场景 ：</span>
                <el-select v-model="search.reportScene" style="width: 150px" placeholder="请选择举报场景" clearable>
                    <el-option v-for="item in reportSceneList" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>操作人：</span>
                <el-input v-model="search.operator" style="width: 150px" placeholder="请输入操作人"></el-input>
            </div>
            <div class="item">
                <el-button type="primary" @click="getList(1)">search</el-button>
                <el-button type="success" @click="getRuleLists">规则</el-button>
            </div>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="tableList">
                <el-table-column prop="createTime" label="举报时间" align="center">
                </el-table-column>
                <el-table-column prop="reportUser" label="举报人" align="left" width="200">
                    <template slot-scope="scope">
                        <div class="info">
                            <p>
                                昵称：<i>{{ scope.row.reportUser.name }}</i>
                            </p>
                            <p>
                                性别：<i>{{
                                    scope.row.reportUser.sex == 2 ? '女性' : scope.row.reportUser.sex == 1 ? '男性' : '未知'
                                }}</i>
                            </p>
                            <p>
                                年龄：<i>{{ scope.row.reportUser.age }}</i>
                            </p>
                            <p>
                                国家：<i>{{ scope.row.reportUser.country }}</i>
                            </p>
                            <p>
                                身份：<i>{{
                                    scope.row.reportUser.gender == 1 ? '用户' : scope.row.reportUser.gender == 2 ? '主播' : '未知'
                                }}</i>
                            </p>
                            <p>
                                历史举报次数：<i>{{
                                    scope.row.reportUser.historyReportCount
                                }}</i>
                            </p>
                            <p>
                                历史被举报次数：<i>{{
                                    scope.row.reportUser.historyBeReportedCount
                                }}</i>
                            </p>
                            <p>
                                历史处理次数：<el-popover placement="right" width="400" trigger="click">
                                    <el-table :data="detailList" border>
                                        <el-table-column property="reportTypeId" label="举报类型">
                                            <template slot-scope="scope">
                                                {{reportTypeList.find(item => item.reportTypeId ===
                                                    scope.row.reportTypeId).reportTypeContent}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="count" label="举报次数"></el-table-column>
                                        <el-table-column property="passCount" label="通过次数"></el-table-column>
                                        <el-table-column property="rejectCount" label="拒绝次数"></el-table-column>
                                    </el-table>
                                    <i style="text-decoration: underline; cursor: pointer" slot="reference"
                                        @click="getReportDetail(scope.row.reportUser.uid, 0)">查看</i>
                                </el-popover>
                            </p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="beReportedUser" label="被举报人" align="left" width="200">
                    <template slot-scope="scope">
                        <div class="info">
                            <p>
                                昵称：<i>{{ scope.row.beReportedUser.name }}</i>
                            </p>
                            <p>
                                性别：<i>{{
                                    scope.row.beReportedUser.sex == 2 ? '女性' : scope.row.beReportedUser.sex == 1 ? '男性' : '未知'
                                }}</i>
                            </p>
                            <p>
                                年龄：<i>{{ scope.row.beReportedUser.age }}</i>
                            </p>
                            <p>
                                国家：<i>{{ scope.row.beReportedUser.country }}</i>
                            </p>
                            <p>
                                身份：<i>{{
                                    scope.row.beReportedUser.gender == 1 ? '用户' : scope.row.beReportedUser.gender == 2 ? '主播' : '未知'
                                }}</i>
                            </p>
                            <p>
                                历史举报次数：<i>{{
                                    scope.row.beReportedUser.historyReportCount
                                }}</i>
                            </p>
                            <p>
                                历史被举报次数：<i>{{
                                    scope.row.beReportedUser.historyBeReportedCount
                                }}</i>
                            </p>
                            <p>
                                历史处理次数：<el-popover placement="right" width="400" trigger="click">
                                    <el-table :data="detailList" border>
                                        <el-table-column property="reportTypeId" label="举报类型">
                                            <template slot-scope="scope">
                                                {{reportTypeList.find(item => item.reportTypeId ===
                                                    scope.row.reportTypeId).reportTypeContent}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="count" label="举报次数"></el-table-column>
                                        <el-table-column property="passCount" label="通过次数"></el-table-column>
                                        <el-table-column property="rejectCount" label="拒绝次数"></el-table-column>
                                    </el-table>
                                    <i style="text-decoration: underline; cursor: pointer" slot="reference"
                                        @click="getReportDetail(scope.row.beReportedUser.uid, 1)">查看</i>
                                </el-popover>
                            </p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="reportTypeId" label="举报原因" align="center">
                    <template slot-scope="scope">
                        {{reportTypeList.find(item => item.reportTypeId === scope.row.reportTypeId).reportTypeContent
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="reportScene" label="举报场景" align="center">
                    <template slot-scope="scope">
                        {{reportSceneList.find(item => item.value === scope.row.reportScene).label}}
                    </template>
                </el-table-column>
                <el-table-column prop="reportScene" label="举报举证" align="center">
                    <template slot-scope="scope">
                        <div class="imgs">
                            <el-image style="width: 100px; height: auto" :src="item"
                                v-for="(item, index) in scope.row.picDescriptionList" :key="`img-${index}-${item}`"
                                :preview-src-list="[item]"></el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="textDescription" label="文字描述" align="center"></el-table-column>
                <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
                <el-table-column prop="operator" label="状态" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.handleStatus === 0 ? '待审核' : scope.row.handleStatus === 1 ? '已拒绝' : '已通过' }}
                    </template>
                </el-table-column>
                <el-table-column prop="operateTime" label="操作时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150" fixed="right">
                    <template slot-scope="scope">
                        <div class="btns">
                            <el-button v-if="scope.row.handleStatus == 0" type="primary"
                                @click="handleReports(scope.row, 0)">通过</el-button>
                            <el-button v-if="scope.row.handleStatus == 0" type="info"
                                @click="handleReports(scope.row, 1)">拒绝</el-button>
                            <el-button type="success" @click="handleReports(scope.row, 2)">备注</el-button>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                :current-page.sync="currentPage" @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 备注 -->
        <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" @close="remarkDialogClose">
            <el-row>
                <span>备注人：{{ remarkPerson }}</span>
            </el-row>
            <el-input type="textarea" v-model="handleInfo.remark" placeholder="请输入备注" :rows="5"></el-input>
            <el-row style="margin-top: 20px;">
                <el-button type="info" @click="remarkDialogClose">取消</el-button>
                <el-button type="primary" @click="handleReportSubmits">提交</el-button>
            </el-row>
        </el-dialog>
        <!-- 规则 -->
        <el-dialog title="规则" :visible.sync="ruleDialogVisible" width="60%" @close="ruleDialogClose">
            <el-row style="margin-bottom: 20px;">
                <el-select v-model="ruleType" placeholder="请选择规则类型" size="small"
                    style="width: 200px; margin-right: 20px;">
                    <el-option v-for="item in ruleTypes" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
                <el-button type="primary" size="small" @click="getRuleList(ruleType)">search</el-button>
                <el-button type="primary" size="small" @click="addNewRule">添加规则</el-button>
            </el-row>
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item v-for="(rule, index) in ruleList" :key="`rule-${index}-${rule.reportTypeId}`"
                    :name="rule.reportTypeId">
                    <template slot="title">
                        <span>规则类型：</span>
                        <el-select v-model="rule.reportTypeId" placeholder="请选择举报类型" size="small"
                            style="width: 200px; margin-right: 20px;">
                            <el-option v-for="item in reportTypeList" :key="item.reportTypeId"
                                :label="item.reportTypeContent" :value="item.reportTypeId">
                            </el-option>
                        </el-select>
                        <span>{{reportTypeList.find(item => item.reportTypeId === rule.reportTypeId)?.reportTypeContent
                            || '未知类型'}}</span>
                    </template>
                    <el-row 
                        v-for="(config, configIndex) in rule.reportConfigList" :key="configIndex" :gutter="2"
                        class="config-row" type="flex" justify="start">
                        <div class="item">
                            <span>处理类型：</span>
                            <el-select v-model="config.handleType" style="margin-right: 10px;width: 100px;"
                                placeholder="请选择处理类型" size="small">
                                <el-option v-for="item in handleTypeList" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                        <div class="item">
                            <span>下限次数：</span>
                            <el-input-number v-model="config.lowerCount" :min="0" size="small"></el-input-number>
                        </div>
                        <div class="item">
                            <span>上限次数：</span>
                            <el-input-number v-model="config.upperCount" :min="0" size="small"></el-input-number>
                        </div>
                        <div class="item">
                            <span>封禁天数：</span>
                            <el-input-number v-model="config.banDays" :min="0" size="small"></el-input-number>
                            <el-button type="danger" size="small" icon="el-icon-delete"
                                @click="removeConfig(rule, configIndex)"></el-button>
                        </div>
                    </el-row>
                    <el-row>
                        <el-button type="primary" size="small" @click="addNewConfig(rule)">添加配置</el-button>
                        <el-button type="danger" size="small" @click="removeRule(index)">删除规则</el-button>

                    </el-row>
                </el-collapse-item>
            </el-collapse>
            <el-row style="margin-top: 20px;">
                <el-button type="info" size="small" @click="ruleDialogClose">取消</el-button>
                <el-button type="success" size="small" @click="saveRule">确认</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            currentPage: 1,
            remarkPerson: null,
            total: 0,
            tableList: [],
            pageSize: 30,
            dateTime: [],
            search: {
                startTime: null,
                endTime: null,
                reportTypeId: null,
                operator: null,
                reportScene: null,
            },
            reportSceneList: [
                {
                    label: 'Video Call',
                    value: 0,
                },
                {
                    label: '私聊',
                    value: 1,
                },
                {
                    label: '资料页',
                    value: 2,
                },
            ],
            handleTypeList: [
                {
                    label: '警告',
                    value: 1
                },
                {
                    label: '封号',
                    value: 2
                },
            ],
            ruleType: 0,
            ruleTypes: [
                {
                    label: '用户',
                    value: 0
                },
                {
                    label: '主播',
                    value: 1
                }],
            handleInfo: {
                handleType: 0,
                remark: null,
                recordId: null,
            },
            reportTypeList: [],
            ruleDialogVisible: false,
            ruleList: [
                {
                    reportTypeId: null,
                    reportConfigList: [
                        {
                            upperCount: 0,
                            lowerCount: 0,
                            banDays: 0,
                            handleType: 1
                        }
                    ]
                }
            ],
            detailList: [],
            activeNames: []
        }
    },
    created() {
        this.getList()
        this.getReportTypeList()
    },
    methods: {
        guaranteedHandleCurrentChange(page) {
            this.currentPage = page
            getList()
        },
        handleDateChange() {
            console.log(this.dateTime)
            if (!this.dateTime) {
                this.search.startTime = null
                this.search.endTime = null
                return
            }
            this.search.startTime = this.dateTime[0] ? this.dateTime[0] : null
            this.search.endTime = this.dateTime[1] ? this.dateTime[1] : null
        },

        // 获取数据列表
        async getList(page) {
            if (page) {
                this.currentPage = 1
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.report_query,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    ...this.search,
                    page: this.currentPage,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.tableList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        ruleDialogClose() {
            this.ruleType = 0
            this.ruleDialogVisible = false
            this.ruleList = [
                {
                    reportTypeId: null,
                    reportConfigList: [
                        {
                            upperCount: 0,
                            lowerCount: 0,
                            banDays: 0,
                            handleType: 1
                        }
                    ]
                }]
        },
        getRuleLists() {
            this.getRuleList(0)
            this.ruleDialogVisible = true
        },
        // 获取规则列表
        async getRuleList(type = 0) {
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.report_rule_query,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    type: type,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.ruleList = res.data.map(item => {
                    return {
                        reportTypeId: +item.reportTypeId,
                        reportConfigList: item.reportConfigList
                    }
                })
                this.activeNames = this.ruleList.map(item => item.reportTypeId)
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        remarkDialogClose() {
            this.dialogVisible = false
            this.handleInfo.remark = null
        },
        handleReports(row, type) {
            if (type == 0) {
                this.handleInfo = {
                    recordId: row.id,
                    handleType: 2,
                    remark: null,
                }
                this.handleReport(this.handleInfo)
            } else if (type == 1) {
                this.handleInfo = {
                    recordId: row.id,
                    handleType: 1,
                    remark: null,
                }
                this.handleReport(this.handleInfo)
            } else {
                this.remarkPerson = row.remarkPerson
                this.handleInfo = {
                    recordId: row.id,
                    handleType: 3,
                    remark: row.remark,
                }
                this.dialogVisible = true
            }
        },
        async handleReportSubmits() {
            this.handleReport(this.handleInfo)
            this.remarkDialogClose()
        },
        // 举报处理
        async handleReport(info) {
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.report_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    ...info,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.getList()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        // 举报处理提交
        async handleReportSubmit(type, info) {
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.report_rule_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    type: type,
                },
                data: [
                    ...info,
                ],
            })
            if (res.code === 0 || res.status === 0) {
                this.getList()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        getReportDetail(uid, type) {
            this.handleReportCount(uid, type)
        },
        // 举报记录次数
        async handleReportCount(uid, type) {
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.report_detail,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    uid: uid,
                    type: type,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.detailList = res.data
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        // 举报类型列表
        async getReportTypeList() {
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.report_typeList,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.reportTypeList = res.data
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        addNewRule() {
            // 创建一个新规则，并设置默认值
            const newRule = {
                reportTypeId: this.reportTypeList.length > 0 ? this.reportTypeList[0].reportTypeId : null,
                reportConfigList: [
                    {
                        upperCount: 0,
                        lowerCount: 0,
                        banDays: 0,
                        handleType: 1
                    }
                ]
            };
            this.ruleList.push(newRule);
            this.activeNames.push(newRule.reportTypeId);
        },
        handleChange(index) {
            if (index === -1) {
                this.ruleList = this.ruleList.filter((_, i) => i !== this.activeNames[0])
                this.activeNames = []
            }
        },
        removeConfig(rule, configIndex) {
            rule.reportConfigList.splice(configIndex, 1)
        },
        addNewConfig(rule) {
            rule.reportConfigList.push({
                upperCount: 0,
                lowerCount: 0,
                banDays: 0,
                handleType: 1
            })
        },
        removeRule(index) {
            this.ruleList.splice(index, 1)
            this.activeNames = []
        },
        async saveRule() {
            // 保存规则到服务器
            await this.handleReportSubmit(this.ruleType, this.ruleList);
            this.ruleDialogClose()
        },
    },
}
</script>

<style scoped lang="scss">
.report {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.info {
    width: max-content;

    p {
        width: max-content;

        i {
            color: #5873f7;
            font-style: normal;
        }
    }
}

.imgs {
    display: flex;
    gap: 5px;
}

.btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    :deep(.el-button) {
        width: 80px;
        margin-left: 0;
    }
}

.config-row {
    display: flex;
    gap: 5px;
    .item{
        width: max-content;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
